"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SortedComplexity = void 0;
exports.convertComplexityToSortedComplexity = convertComplexityToSortedComplexity;
exports.convertSortedComplexityToComplexity = convertSortedComplexityToComplexity;
const Complexity_1 = require("./Complexity");
var SortedComplexity;
(function (SortedComplexity) {
    SortedComplexity["EASY"] = "1EASY";
    SortedComplexity["MEDIUM"] = "2MEDIUM";
    SortedComplexity["HARD"] = "3HARD";
})(SortedComplexity || (exports.SortedComplexity = SortedComplexity = {}));
function convertComplexityToSortedComplexity(complexity) {
    switch (complexity) {
        case Complexity_1.Complexity.EASY:
            return SortedComplexity.EASY;
        case Complexity_1.Complexity.MEDIUM:
            return SortedComplexity.MEDIUM;
        case Complexity_1.Complexity.HARD:
            return SortedComplexity.HARD;
        default:
            throw new Error('Invalid complexity');
    }
}
function convertSortedComplexityToComplexity(sortedComplexity) {
    switch (sortedComplexity) {
        case SortedComplexity.EASY:
            return Complexity_1.Complexity.EASY;
        case SortedComplexity.MEDIUM:
            return Complexity_1.Complexity.MEDIUM;
        case SortedComplexity.HARD:
            return Complexity_1.Complexity.HARD;
        default:
            throw new Error('Invalid sorted complexity');
    }
}
//# sourceMappingURL=SortedComplexity.js.map